module.exports = __webpack_public_path__ + "static/dummy300x300-subscriptions-71de58dcee829986306f7a8f0c5d3d41.png";